import AnimeCard from './AnimeCard'

export default AnimeCard;